export default __webpack_public_path__ + "static/media/shadow.2ca24e71.png";